/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAggregatedPie', {
                parent: 'leadManagementAggregated',
                url: '/pie',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadManagementAggregated/pie/pie.html',
                controller: 'LeadManagementAggregatedPieController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
